import React from 'react';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel, PIXEL_ID } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { ProblemSolution } from './components/ProblemSolution';
import { ProductShowcase } from './components/ProductShowcase';
import { PurchasePopup } from './components/PurchasePopup';
import { Testimonials } from './components/Testimonials';
import { Volumes } from './components/Volumes';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white text-plum-950 selection:bg-blush-300 selection:text-plum-950" data-id="element-0" data-mp="2wj8cxn0bok3n">
      <MetaPixel data-id="element-1" data-mp="28sbcb6dz997p" />
      <main data-id="element-2" data-mp="23vcjqs9ypabm">
        <Hero data-id="element-3" data-mp="23vktwcepa1j4" />
        <ProblemSolution data-id="element-4" data-mp="23w4e5zrtp20b" />
        <ProductShowcase data-id="element-5" data-mp="23utbk3a460as" />
        <Volumes data-id="element-6" data-mp="23ti8y6semyl9" />
        <Bonuses data-id="element-7" data-mp="3ik7gwiph6frp" />
        <Pricing id="offer" titleId="offer-title" data-id="element-8" data-mp="3ikr002qv3a7b" />
        <Differentiators data-id="element-9" data-mp="3ihv2ugmu8pjx" />
        <Testimonials data-id="element-10" data-mp="3mlawr57iwbsx" />
        <Faq data-id="element-11" data-mp="3mkrchhuehbbq" />
        <FinalClose data-id="element-12" data-mp="3mk85uxa7a9d0" />
      </main>
      <Footer data-id="element-13" data-mp="3mjg8pi0yg3km" />
      <PurchasePopup data-id="element-14" data-mp="3rc9d24sih9w6" />
      <noscript data-id="element-15" data-mp="3rbrcivytg9ig">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-16" data-mp="3rdarmj8qkein" />
      </noscript>
    </div>;
}